import type { Action } from "@/components/MenuButton";

export type TableRowMenu = {
  rowId: string;
  actions: Action[];
};

export function actionId(rowId: string) {
  return `action-${rowId}`;
}
